import { Card, CardActions, CardContent, Grid } from "@material-ui/core";
import { List } from "@material-ui/icons";
import React from "react";
import { getClickButton } from "../../../../functions/getButtons";
import IIntegration from "../../../../models/IIntegration";
import { useIntegrationContext } from "../../contexts/IntegrationContext";
import SelectAPIsDialog from "../../dialogs/apis/SelectAPIsDialog";
import CustomAPIFieldsDialog from "../../dialogs/fields/CustomAPIFieldsDialog";
import { IntegrationStatuses } from "../../IntegrationStatuses";
import IntegrationAPIsTable from "./IntegrationAPIsTable";

interface IIntegrationAPIDetailsProps {
  token: string;
  username: string;
  integration: IIntegration;
  setIntegrationErrors: (val: string[]) => void;
}

export const IntegrationAPIDetails = (props: IIntegrationAPIDetailsProps) => {
  const { token, username, integration, setIntegrationErrors } = props;
  const { apis, setApis, access, showCustomAPIFieldsDialog, setShowCustomAPIFieldsDialog } = useIntegrationContext();

  const [showSelectAPIsDialog, setShowSelectAPIsDialog] = React.useState<boolean>(false);

  const getAPIsInUse = (): JSX.Element => {
    if (apis.length > 0) {
      return (
        <Grid item xs={12}>
          <IntegrationAPIsTable
            showFieldButtons={integration.Status.ID != IntegrationStatuses.Discontinued}
            name="APIs In Use"
            integration={integration}
            apis={apis}
          />
        </Grid>
      );
    } else {
      return (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <h3>APIs In Use</h3>
          </Grid>
          <Grid item xs={12}>
            No APIs have been selected
          </Grid>
        </Grid>
      );
    }
  };

  return (
    <>
      <SelectAPIsDialog
        isOpen={showSelectAPIsDialog}
        token={token}
        username={username}
        closeDialog={() => setShowSelectAPIsDialog(false)}
        integration={integration}
        currentAPIs={apis}
        setIntegrationErrors={setIntegrationErrors}
        setApis={setApis}
      />
      <CustomAPIFieldsDialog isOpen={showCustomAPIFieldsDialog} onClose={() => setShowCustomAPIFieldsDialog(false)} access={access} />
      <Card>
        <CardContent>{apis && getAPIsInUse()}</CardContent>
        <CardActions>
          {integration.Status.ID != IntegrationStatuses.Discontinued &&
            getClickButton(integration.Status.ID === IntegrationStatuses.AvailableForCustomers ? "Request API Update" : "Select APIs", <List />, () =>
              setShowSelectAPIsDialog(true),
            )}
        </CardActions>
      </Card>
    </>
  );
};
